import { TableHoverActions, useModal, withModalConditionalRender } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../../../hooks'
import { useInvoice } from '../../../../../../../invoices'
import { InvoiceReconciliationModal as InvoiceReconciliationModalComponent } from '../../../../../../../invoices/elements/InvoiceReconclliationModal/InvoiceReconciliationModal'
import { TransactionsInvoicesActionType } from '../../../TransactionsTableStaticActions/utils/getInvoicesActions'

interface TransactionsTableStaticActionsProps {
  originatorId: string
}

const InvoiceReconciliationModal = withModalConditionalRender(InvoiceReconciliationModalComponent)

const getInvoiceReconciliationModalId = (id: string) => `${id}-invoice-reconciliation-hover-action`

export const InvoicesHoverActions = ({ originatorId }: TransactionsTableStaticActionsProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()

  const registerInvoicePaymentModalId = getInvoiceReconciliationModalId(originatorId)
  const { open: openRegisterInvoicePaymentModal } = useModal(registerInvoicePaymentModalId)

  const { data: invoiceData } = useInvoice(originatorId)

  const invoice = invoiceData?.invoice
  const isInvoicePaid = invoice?.isPaid

  const handleActionClick = useCallback(() => {
    track('xxx - bookkeeping - HoverAction Clicked', {
      list: 'Invoices',
      button: TransactionsInvoicesActionType.RegisterPayment,
    })
    openRegisterInvoicePaymentModal()
  }, [openRegisterInvoicePaymentModal, track])

  if (isInvoicePaid) {
    return <></>
  }

  return (
    <>
      <TableHoverActions>
        <TableHoverActions.Item
          icon="handCoins"
          label={t('transactions.table.static_actions.bills.registerPayment')}
          onClick={handleActionClick}
        />
      </TableHoverActions>

      {invoice && <InvoiceReconciliationModal subject={invoice} id={getInvoiceReconciliationModalId(originatorId)} />}
    </>
  )
}
